// Venue display names. A TRACK is a league (roster/standings/races); the
// STAGE × WEATHER pair is the LOCATION of one race. New racecards and race
// summaries carry display names from the backend registries; anything older
// (or any slug-only surface, e.g. a horse's track) falls back to the v1
// registry names / title-cased slug. Ids remain the verified facts — these
// helpers are presentation only.

const STAGE_NAMES_V1: Record<string, string> = {
  canyon: "Canyon",
  rose: "Rose Highlands",
  desert: "Desert Valley",
  midnight: "Midnight Circuit",
};

const WEATHER_NAMES_V1: Record<string, string> = {
  clear: "Clear",
  rain: "Rain Storm",
  mist: "Mist",
  dust: "Dust Storm",
};

export function titleCaseSlug(slug: string): string {
  return slug
    .split("-")
    .filter(Boolean)
    .map((word) => `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`)
    .join(" ");
}

export function trackTitle(row: { track: string; trackName?: string }): string {
  return row.trackName ?? titleCaseSlug(row.track);
}

/** A pack's human label: the league it draws from plus its kind. Falls back
 * to the series code for payloads that predate `trackName`. */
export function packLabel(row: {
  series: string;
  trackName?: string;
  kind?: string;
  seriesKind?: string;
}): string {
  const kind = row.kind ?? row.seriesKind;
  if (!row.trackName) return row.series.replaceAll("-", " ");
  return `${row.trackName} ${kind === "repack" ? "re-pack" : "pack"}`;
}

export function stageTitle(row: {
  stage?: string;
  stageName?: string;
}): string {
  if (row.stageName) return row.stageName;
  if (!row.stage) return "";
  return STAGE_NAMES_V1[row.stage] ?? titleCaseSlug(row.stage);
}

export function weatherTitle(row: {
  weather?: string;
  weatherName?: string;
}): string {
  if (row.weatherName) return row.weatherName;
  if (!row.weather) return "";
  return WEATHER_NAMES_V1[row.weather] ?? titleCaseSlug(row.weather);
}

/** "Midnight Circuit · Mist" — the location line of one race. */
export function venueLabel(row: {
  stage?: string;
  stageName?: string;
  weather?: string;
  weatherName?: string;
}): string {
  return [stageTitle(row), weatherTitle(row)].filter(Boolean).join(" · ");
}
